import { IAccordionData } from "@/models/IAccordionData";
import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import AccordionWrapper from "../../components/accordionWrapper";
import Arrow from "../../components/Arrow";

const accordionDataRaw = [
  {
    header: "Drug Metabolism & Pharmacokinetics (DMPK)",
    description: "",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "Computational Assessment",
        data: "Diverse computational tools to inform molecule prioritization",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "In Vitro Drug Metabolism & Pharmacokinetics (DMPK) Issue ID",
        data: "Assess aqueous solubility, plasma protein binding, microsomal stability, matrix stability, permeability, and initial drug interaction liabilities of small molecules",
      },
      {
        headerSection: "",
        icon: <></>,
        header:
          "Drug Metabolism &  Pharmacokinetics (DMPK) Full Characterization",
        data: "Multi-property optimization and identifying metabolism-related and transporter-related risks for Development Candidates",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Preclinical Pharmacokinetic (PK) Studies",
        data: "PK studies to assess absorption, distribution, metabolism, and excretion",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Bioanalytical Expertise",
        data: "Immunoassay method feasibility plus method development, validation, and analysis of drug levels in plasma, tissues, and excreta from preclinical species",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Human Dose Predictions",
        data: "Mechanistic modeling based on in vitro human clearance and desired target engagement to predict likely human efficacious dose range",
      },
    ],
  },
  {
    header: "Pharmacokinetics & Pharmacodynamics (PKPD)",
    description:
      "Driving toward the right molecule at the right dose for the right patient",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "Discovery and Preclinical",
        data: [
          "Target of interest or combinations",
          "Consulting on strategy for optimizing molecule properties",
          "Prioritizing molecule selection",
          "Translating from preclinical to clinical",
        ],
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Phase 1 to Phase 2b",
        data: [
          "Pharmacodynamic/efficacy/safety relationships",
          "Optimizing doses and regimen selection in clinical trials",
          "Designing fit-for-purpose clinical pharmacology plan",
          "Developing clinical formulation and device bridging strategy",
        ],
      },
    ],
  },
];
const Adme = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //DMPK
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4">
          <div className="my-8 grid xl:grid-cols-3 grid-cols-1 gap-4 xl:gap-2">
            <div className="col-span-3 xl:flex items-center justify-around text-2xl hidden">
              <div className="font-semibold px-4" id="capabilities-s3-1">
                Lead Molecules
              </div>

              <div className="font-semibold px-4" id="capabilities-s3-2">
                Development Candidate
              </div>
              {props.accordionOpenHeader === accordionDataRaw[0].header && (
                <>
                  <Arrow fromId="capabilities-s3-1" toId="capabilities-s3-2" />
                  <Arrow fromId="capabilities-s3-2" toId="capabilities-s3-3" />
                </>
              )}
              <div className="font-semibold px-4" id="capabilities-s3-3">
                Investigational New Drug (IND)
              </div>
            </div>

            <div className="xl:hidden">
              <div className="font-semibold pb-4" id="capabilities-s3-1-mob">
                Lead Molecules
              </div>
              <div className="ml-16">
                <div className="flex flex-col gap-4">
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-4">
                      {accordionDataRaw[0].data[0].header}
                    </div>
                    {accordionDataRaw[0].data[0].data}
                  </CapabilitiesTextContainer>
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-4">
                      {accordionDataRaw[0].data[3].header}
                    </div>
                    {accordionDataRaw[0].data[3].data}
                  </CapabilitiesTextContainer>
                </div>
              </div>
              <div className="font-semibold py-4" id="capabilities-s3-2-mob">
                Devlopment Candidate
              </div>
              <div className="ml-16">
                <div className="flex flex-col gap-4">
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-4">
                      {accordionDataRaw[0].data[1].header}
                    </div>
                    {accordionDataRaw[0].data[1].data}
                  </CapabilitiesTextContainer>
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-4">
                      {accordionDataRaw[0].data[4].header}
                    </div>
                    {accordionDataRaw[0].data[4].data}
                  </CapabilitiesTextContainer>
                </div>
              </div>
              <div className="font-semibold py-4" id="capabilities-s3-3-mob">
                Investigational new drug (IND)
              </div>
              <div className="ml-16">
                <div className="flex flex-col gap-4">
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-4">
                      {accordionDataRaw[0].data[2].header}
                    </div>
                    {accordionDataRaw[0].data[2].data}
                  </CapabilitiesTextContainer>
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-4">
                      {accordionDataRaw[0].data[5].header}
                    </div>
                    {accordionDataRaw[0].data[5].data}
                  </CapabilitiesTextContainer>
                </div>
              </div>
              {props.accordionOpenHeader === accordionDataRaw[0].header && (
                <>
                  <Arrow
                    fromId="capabilities-s3-1-mob"
                    toId="capabilities-s3-2-mob"
                    type="mobile"
                  />
                  <Arrow
                    fromId="capabilities-s3-2-mob"
                    toId="capabilities-s3-3-mob"
                    type="mobile"
                  />
                </>
              )}
            </div>
          </div>
          <div className="my-8 xl:grid xl:grid-cols-3 grid-cols-1 gap-4 xl:gap-2 hidden">
            {accordionDataRaw[0].data.map((el) => (
              <CapabilitiesTextContainer>
                <div className="font-medium mb-4">{el.header}</div>
                {el.data}
              </CapabilitiesTextContainer>
            ))}
          </div>
        </div>
      ),
    },
    {
      header: accordionDataRaw[1].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light">
            {accordionDataRaw[1].description}
          </div>
          <div className="my-8 grid xl:grid-cols-2 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[1].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div className="font-medium mb-2">{el.header}</div>
                  <ul className="px-4">
                    {Array.isArray(el.data) &&
                      el.data.map((point) => <li className="py-1">{point}</li>)}
                  </ul>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      accordionOpenHeader={props.accordionOpenHeader}
      setOpen={props.setAccordionOpenHeader}
    />
  );
};

export default Adme;
